import type { RuleHandler } from "../types";
import { outcomesInclude } from "../outcomesInclude";

// Ids are UUIDs, which the backend compares regardless of case.
const checkAllCompetitorIdsMustMatch: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  return outcomesInclude(
    new Set(
      requirementAttributes?.competitorIds?.map((id) => id.toLowerCase()),
    ),
    context.selection.competitorIds.map((id) => id?.toLowerCase()),
    requirementAttributes?.allCompetitorIdsMustMatch || false,
  );
};

export { checkAllCompetitorIdsMustMatch };
